import { EventTypeInputGroup } from '../types/ViewModel/EventTypeInputGroup';
import { EventTypeInputGroupItem } from '../types/ViewModel/EventTypeInputGroupItem';
import { EventTypeInputGroupItemFactory } from './EventTypeInputGroupItemFactory';
import { EventTypeInputGroupBM } from '../types/BusinessModel/EventTypeInputGroupBM';

export class EventTypeInputGroupFactory {
    private eventTypeInputGroupItemFactory = new EventTypeInputGroupItemFactory();

    constructor() {}

    public newEventTypeInputGroup(itemList: EventTypeInputGroupBM[]): EventTypeInputGroup[] {
        const eventTypeInputGroupArray: EventTypeInputGroup[] = [];
        if (itemList && itemList.length > 0) {
            itemList.map((item) => eventTypeInputGroupArray.push(this.newItem(item)));
        }
        return eventTypeInputGroupArray;
    }

    private newItem(item: EventTypeInputGroupBM): EventTypeInputGroup {
        const eventTypeInputGroupItemArray: EventTypeInputGroupItem[] = this.eventTypeInputGroupItemFactory.newEventTypeInputGroupItem(
            item.eventTypeInputGroupItemList
        );
        // const eventTypeInputArraySorted = eventTypeInputGroupItemArray.sort(etigi => etigi.itemOrder);
        const eventTypeInputArraySorted = eventTypeInputGroupItemArray.sort((a, b) => (a.itemOrder > b.itemOrder ? 1 : -1));
        return new EventTypeInputGroup(item.eventTypeInputGroupId, item.eventTypeId, item.heading, item.sectionOrder, eventTypeInputArraySorted);
    }
}
